import { Stack, Typography } from "@mui/material";
import { graphql } from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";
import {
  InternTempoConnectionCard_brand$data,
  InternTempoConnectionCard_brand$key,
} from "./__generated__/InternTempoConnectionCard_brand.graphql";
import CardSection from "../../../components/CardSection";
import InternTempoConnectButton from "./tempo/InternTempoConnectButton";

const brandFragment = graphql`
  fragment InternTempoConnectionCard_brand on BrandType {
    id
    tempoApiToken
  }
`;

const InternTempoConnectedCard = ({
  brand,
}: {
  brand: InternTempoConnectionCard_brand$data;
}) => {
  return (
    <CardSection title="Tempo Connection">
      <Stack spacing={1} direction="row" alignItems="center">
        <Typography>Connected:</Typography>
        <Typography
          variant="body1"
          color="white"
          sx={{
            backgroundColor: "gray",
            padding: 0.5,
            borderRadius: 1,
          }}
        >
          {brand.tempoApiToken}
        </Typography>
      </Stack>
    </CardSection>
  );
};

const InternTempoDisconnectedCard = ({
  brand,
}: {
  brand: InternTempoConnectionCard_brand$data;
}) => {
  return (
    <CardSection
      title="Tempo Connection"
      actions={<InternTempoConnectButton brandId={brand.id} />}
    >
      <Typography>No brand connection</Typography>
    </CardSection>
  );
};

type Props = {
  brand: InternTempoConnectionCard_brand$key;
};

const InternTempoConnectionCard = ({ brand: brandKey }: Props) => {
  const brand = useFragment(brandFragment, brandKey);
  if (brand.tempoApiToken) {
    return <InternTempoConnectedCard brand={brand} />;
  }
  return <InternTempoDisconnectedCard brand={brand} />;
};

export default InternTempoConnectionCard;
